import type { ReactNode } from "react";
import { Badge } from "@volca/ui/components/ui/badge";
import { PageTitle } from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface RosterPageHeaderProps {
  status?: { publishedVersion: number | null };
  description?: ReactNode;
  actions?: ReactNode;
}

export const RosterPageHeader = ({
  status,
  description,
  actions,
}: RosterPageHeaderProps) => (
  <Stack
    direction="row"
    justify="between"
    align="center"
    gap={4}
    className="w-full flex-wrap gap-y-2"
  >
    <Stack align="start" gap={1} className="min-w-0">
      <Stack direction="row" align="center" gap={2} className="flex-wrap">
        <PageTitle>Payroll roster</PageTitle>
        {status &&
          (status.publishedVersion != null ? (
            <>
              <Badge variant="secondary" size="sm">
                v{status.publishedVersion}
              </Badge>
              <Badge variant="secondary" color="success" size="sm">
                Published
              </Badge>
            </>
          ) : (
            <Badge variant="secondary" size="sm">
              Draft
            </Badge>
          ))}
      </Stack>
      {description && (
        <Text tone="muted" className="text-pretty">
          {description}
        </Text>
      )}
    </Stack>
    {actions && (
      <Stack direction="row" align="center" gap={2} className="flex-wrap">
        {actions}
      </Stack>
    )}
  </Stack>
);
